<!--
 * @Description: 
 * @Date: 2020-11-10 16:25:22
 * @LastEditors: jml
 * @LastEditTime: 2020-11-10 16:27:16
-->
<template>
  <svg width="20" height="20" viewport="0 0 20 20">
    <path
      d="M0 4 L0 12 L6.928203230275509 16 L13.856406460551018 12 L13.856406460551018 4 L6.928203230275509 0 z"
      :fill="color"
      stroke-width="0"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      default: '',
      type: String
    }
  }
};
</script>

<style></style>
